import Button from "./Button";
export default Button;


// WEBPACK FOOTER //
// ./src/Button/index.js